
export function getFileExtension(fileNameWithExtension: string) {
    var fileExtension = '';

    if (fileNameWithExtension !== '') {
        var lastDotPosition = fileNameWithExtension.lastIndexOf('.');
        
        fileExtension =  (lastDotPosition < 1) ? '' : fileNameWithExtension.substring(lastDotPosition).toLocaleLowerCase();
    }

    return fileExtension;
}

export function getFileNameWithoutExtension(fileNameWithExtension: string) {
    var fileName = '';

    if(fileNameWithExtension != undefined) {
        let fileExtension = getFileExtension(fileNameWithExtension);
        fileName = fileNameWithExtension.replace(fileExtension, '');
    }

    return fileName;
}

export function getFileIconUrlByFileExtension(fileExtension: string) {
    var fileIconUrl = '';

    switch (fileExtension) {
        case '.doc':
            fileIconUrl = '/imgs/icon-doc.svg';
            break;
        case '.docx':
            fileIconUrl = '/imgs/icon-doc.svg';
            break;
        case '.xls':
            fileIconUrl = '/imgs/icon-xls.svg';
            break;
        case '.xlsx':
            fileIconUrl = '/imgs/icon-xls.svg';
            break;
        case '.ppt':
            fileIconUrl = '/imgs/icon-ppt.svg';
            break;
        case '.pptx':
            fileIconUrl = '/imgs/icon-ppt.svg';
            break;
        case '.pdf':
            fileIconUrl = '/imgs/icon-pdf.svg';
            break;
        case '.jpg':
        case '.jpeg':
            fileIconUrl = '/imgs/icon-jpg.svg';
            break;
        case '.png':
            fileIconUrl = '/imgs/icon-png.svg';
            break;
        default:
            fileIconUrl = '/imgs/icon-unknown-file.svg';
    }

    return fileIconUrl;
}


// WEBPACK FOOTER //
// ./src/utils/uploadFileUtility.ts